import React from 'react';
import { useNavigate } from 'react-router-dom';
import apiHooks from '../../../hooks/apiHooks';
import ListDataPage from '../../../components/pages/ListDataPage';
import dayjs from 'dayjs';
import RevealDropdown, {
  RevealDropdownTrigger
} from 'components/base/RevealDropdown';
import ActionDropdownItems from 'components/common/ActionDropdownItems';
import { fetchSalesInstitutes } from '../../../services/salesInstitutesService';

interface ActionItem {
  eventKey: string;
  label: string;
  type: 'function' | 'redirect'; // Ensure type is restricted
  callback?: () => void;
  url?: string;
  className?: string;
  divider?: boolean;
}

const AllSalesInstitutes = () => {
  const navigate = useNavigate(); // React Router hook for navigation

  // Function to return properly typed actions for each row
  const getActions = (sales_institute_id: string): ActionItem[] => [
    {
      eventKey: '2',
      label: 'Edit',
      type: 'function',
      callback: () =>
        navigate(`/sales/sales-institutes/edit-institute/${sales_institute_id}`)
    },
    {
      eventKey: '3',
      label: 'Remove',
      type: 'function',
      // callback: () => deleteSalesService(service_id),
      className: 'text-danger'
    },
    {
      eventKey: '3',
      label: 'View',
      type: 'function',
      callback: () =>
        navigate(
          `/sales/sales-institutes/institute-details/${sales_institute_id}`
        )
    },
    {
      eventKey: '3',
      label: 'Create Subscription',
      type: 'function',
      callback: () =>
        navigate(
          `/sales/subscription/create-subscription?institute_id=${sales_institute_id}`
        ),
      className: 'text-danger'
    },
    {
      eventKey: '3',
      label: 'Create Order',
      type: 'function',
      callback: () =>
        navigate(
          `/sales/order/create-order?institute_id=${sales_institute_id}`
        ),
      className: 'text-danger'
    }
  ];

  const columns = [
    { accessorKey: 'sales_institute_id', header: 'Institute ID' },
    { accessorKey: 'institute_name', header: 'Institute Name' },
    {
      accessorKey: 'user',
      header: 'Assigned To',
      cell: ({ row }: { row: any }) => {
        const user = row.original.user;
        return user ? `${user.username} ${user.email} ${user.role}` : 'N/A'; // Handle cases where user data might be missing
      }
    },
    { accessorKey: 'CDC_FLAG', header: 'Status' },
    {
      accessorKey: 'created_at',
      header: 'Created At',
      cell: ({ row }: { row: any }) => (
        <span>
          {dayjs(row.original.created_at).format('DD/MM/YYYY HH:mm:ss')}
        </span>
      )
    },
    {
      id: 'action',
      header: 'Actions',
      cell: ({ row }: { row: any }) => (
        <RevealDropdownTrigger style={{ zIndex: '999' }}>
          <RevealDropdown>
            <ActionDropdownItems
              actions={getActions(row.original.sales_institute_id)}
            />
          </RevealDropdown>
        </RevealDropdownTrigger>
      ),
      meta: {
        headerProps: { style: { width: '7%' } },
        cellProps: { className: 'text-center' }
      }
    }
  ];

  return (
    <ListDataPage
      apiHook={apiHooks.useSalesInstitutes}
      entityName="Sales Institutes"
      columns={columns}
    />
  );
};

export default AllSalesInstitutes;
